import DemoScaleWrapper from './DemoScaleWrapper';
import { ONBOARDING_ILLUSTRATION_CLASS } from './onboardingLayout';

export default function OnboardingSlide({ illustration, title, children }) {
  return (
    <div className="flex flex-col pb-2">
      <div
        className={`mb-3 shrink-0 overflow-hidden rounded-xl bg-[#EFF6FF] p-1 sm:mb-4 sm:p-1.5 ${ONBOARDING_ILLUSTRATION_CLASS}`}
      >
        <DemoScaleWrapper>{illustration}</DemoScaleWrapper>
      </div>
      {title && (
        <h2 className="mb-2 shrink-0 text-center text-lg font-bold leading-snug text-[#1E40AF] sm:text-2xl">
          {title}
        </h2>
      )}
      <div className="space-y-2.5 break-words text-[13px] leading-relaxed text-gray-600 sm:space-y-3 sm:text-sm">
        {children}
      </div>
    </div>
  );
}
